import React, { useEffect, useState } from "react";
import Header from "../../Core/Header";
import { Section } from "../../Core/Section";
import { useSelector } from "react-redux";
import { getAgentList } from "../../Services/Operations/ProductAPI";
import { baseURL2 } from "../../Services/api_endpoints";

const Agent = () => {
  const [agentList,setAgentLsit]=useState([])

  const[modalOpen,setModalOpen]=useState(false)
  const[modalAgent,setModalAgent]=useState(null)

  const token = useSelector((state) => state.user.token);


 const[editmodal,setEditModal]=useState(false)

 const[editadharimage,setEditadharimage]=useState(null)

        const [currentPage, setCurrentPage] = useState(1);
      const itemsPerPage = 10;
      
      const indexOfLast = currentPage * itemsPerPage;
      const indexOfFirst = indexOfLast - itemsPerPage;
      
      const currentUsers = agentList.slice(indexOfFirst, indexOfLast);

const handleFetchAgentList=async()=>{
  try {
    const response=await getAgentList(token)
    console.log("agents :",response.data);
    setAgentLsit(response.data)
    
  } catch (error) {
    console.log(error);
    
  }
}

useEffect(() => {
  
  handleFetchAgentList()
}, [])





  return (
    <div id="main_content">
   
      <Header />

      <div class="page">
   
        <Section/>
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <h1 className="page-title">Agent</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">RNDSAN</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Agent
                  </li>
                </ol>
              </div>
              <ul className="nav nav-tabs page-header-tab">
                <li className="nav-item">
                  <a
                    className="nav-link active"
                    data-toggle="tab"
                    href="#Agent-all"
                  >
                    List View
                  </a>
                </li>
               
               
                <li className="nav-item">
                  <a className="nav-link" data-toggle="tab" href="#Agent-grid">
                    Grid
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>


        <div className="section-body mt-4">
          <div className="container-fluid">
            <div className="tab-content">
              <div className="tab-pane active" id="Agent-all">
                <div className="card">
                  <div className="table-responsive">
                    <table className="table table-hover table-vcenter text-nowrap table-striped mb-0">
                      <thead>
                        <tr>
                          <th style={{textAlign:"center"}}>Id</th>
                          <th style={{textAlign:"center"}}>Name</th>
                         
                          <th style={{textAlign:"center"}}>Bank Name</th>
                          <th style={{textAlign:"center"}}>IFSC Code</th>
                          <th style={{textAlign:"center"}}>Branch Name</th>
                        
                         
                          <th style={{textAlign:"center"}}>Adhaar</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          currentUsers.map((item,indx)=>(
                             <tr>
                              <td>{indexOfFirst+indx+1}</td>
                         
                          <td>
                            <div className="font-15">{item.firstName}</div>
                          </td>
                         
                          <td>
                            <span className="text-muted">{item.bankName}</span>
                          </td>
                          <td>{item.ifscCode}</td>
                          <td>
                            {item.bankBranch}
                          </td>
                         
                          <td>
                            <button
                              type="button"
                              className="btn btn-icon btn-sm"
                              title="View"
                              onClick={()=>{
                                setModalAgent(item)
                                setModalOpen(true)
                              }}
                            >
                              <i className="fa fa-eye" />
                            </button>
                            
                           
                          </td>
                        </tr>
                          ))
                        }
                       
                       
                        
                        
                      </tbody>
                    </table>

                           <div className="pagination mt-3" style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
                             <button
    disabled={currentPage === 1}
    onClick={() => setCurrentPage((prev) => prev - 1)}
    className="btn btn-primary btn-sm me-2"
  >
    Prev
                     </button>

                      <span> Page {currentPage} of {Math.ceil(agentList.length / itemsPerPage)} </span>

                  <button
    disabled={currentPage === Math.ceil(agentList.length / itemsPerPage)}
    onClick={() => setCurrentPage((prev) => prev + 1)}
    className="btn btn-primary btn-sm ms-2"
  >
    Next
               </button>
</div>
                  </div>
                </div>
              </div>
              <div className="tab-pane" id="Agent-grid">
                <div className="row">

                  {

                  agentList.map(item=>(

                  
                  <div className="col-xl-3 col-lg-4 col-md-6">
                    <div className="card">
                      <div className="card-body text-center">
                        <img
                          className="card-profile-img"
                          src="../assets/images/sm/avatar1.jpg"
                          alt
                        />
                        <h5 className="mb-0">{item.firstName}</h5>
                       <span>{item.bankBranch}</span>
                        <div className="text-muted">{item.bankName}</div>
                        <p className="mb-4 mt-3">
                         {item.ifscCode}
                        </p>
                        <button className="btn btn-primary btn-sm"
                          onClick={()=>{
                                setModalAgent(item)
                                setModalOpen(true)
                              }}
                        >
                          Adhaar
                        </button>
                      </div>
                    </div>
                  </div>
                  ))
                }
                  
                  
                </div>
              </div>
              <div className="tab-pane" id="Agent-profile">
                <div className="row">
                  <div className="col-xl-4 col-md-12">
                    <div className="card">
                      <div className="card-body w_user">
                        <div className="user_avtar">
                          <img
                            className="rounded-circle"
                            src="../assets/images/sm/avatar1.jpg"
                            alt
                          />
                        </div>
                        <div className="wid-u-info">
                          <h5>Dessie Parks</h5>
                          <p className="text-muted m-b-0">
                            119 Peepee Way, Hilo, HI, 96720
                          </p>
                          <ul className="list-unstyled">
                            <li>
                              <h5 className="mb-0">270</h5>
                              <small>Followers</small>
                            </li>
                            <li>
                              <h5 className="mb-0">310</h5>
                              <small>Following</small>
                            </li>
                            <li>
                              <h5 className="mb-0">908</h5>
                              <small>Liks</small>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header">
                        <h3 className="card-title">About Me</h3>
                        <div className="card-options ">
                          <a
                            href="#"
                            className="card-options-collapse"
                            data-toggle="card-collapse"
                          >
                            <i className="fe fe-chevron-up" />
                          </a>
                          <a
                            href="#"
                            className="card-options-remove"
                            data-toggle="card-remove"
                          >
                            <i className="fe fe-x" />
                          </a>
                        </div>
                      </div>
                      <div className="card-body">
                        <p>
                          Hello I am Celena Anderson a Clerk in Xyz College USA.
                          I love to work with all my college Agent and seniour
                          professors.
                        </p>
                        <ul className="list-group">
                          <li className="list-group-item">
                            <b>Gender </b>
                            <div>Female</div>
                          </li>
                          <li className="list-group-item">
                            <b>Operation Done </b>
                            <div>30+</div>
                          </li>
                          <li className="list-group-item">
                            <b>Degree </b>
                            <div>M.Com.</div>
                          </li>
                          <li className="list-group-item">
                            <b>Designation</b>
                            <div>Jr. Clerk</div>
                          </li>
                          <li className="list-group-item">
                            <div className="clearfix">
                              <div className="float-left">
                                <strong>Telly</strong>
                              </div>
                              <div className="float-right">
                                <small className="text-muted">35%</small>
                              </div>
                            </div>
                            <div className="progress progress-xxs">
                              <div
                                className="progress-bar bg-azure"
                                role="progressbar"
                                style={{ width: "35%" }}
                                aria-valuenow={35}
                                aria-valuemin={0}
                                aria-valuemax={100}
                              />
                            </div>
                          </li>
                          <li className="list-group-item">
                            <div className="clearfix">
                              <div className="float-left">
                                <strong>Account</strong>
                              </div>
                              <div className="float-right">
                                <small className="text-muted">72%</small>
                              </div>
                            </div>
                            <div className="progress progress-xxs">
                              <div
                                className="progress-bar bg-red"
                                role="progressbar"
                                style={{ width: "72%" }}
                                aria-valuenow={72}
                                aria-valuemin={0}
                                aria-valuemax={100}
                              />
                            </div>
                          </li>
                          <li className="list-group-item">
                            <div className="clearfix">
                              <div className="float-left">
                                <strong>MS Office</strong>
                              </div>
                              <div className="float-right">
                                <small className="text-muted">60%</small>
                              </div>
                            </div>
                            <div className="progress progress-xxs">
                              <div
                                className="progress-bar bg-blue"
                                role="progressbar"
                                style={{ width: "60%" }}
                                aria-valuenow={60}
                                aria-valuemin={0}
                                aria-valuemax={100}
                              />
                            </div>
                          </li>
                        </ul>
                      </div>
                      <div className="card-footer text-center">
                        <div className="row">
                          <div className="col-md-4 col-sm-4 col-6">
                            <div className="font-18 font-weight-bold">37</div>
                            <div>Projects</div>
                          </div>
                          <div className="col-md-4 col-sm-4 col-6">
                            <div className="font-18 font-weight-bold">51</div>
                            <div>Tasks</div>
                          </div>
                          <div className="col-md-4 col-sm-4 col-6">
                            <div className="font-18 font-weight-bold">61</div>
                            <div>Uploads</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-8 col-md-12">
                    <div className="card">
                      <div className="card-header">
                        <h3 className="card-title">Timeline Activity</h3>
                        <div className="card-options">
                          <a
                            href="#"
                            className="card-options-collapse"
                            data-toggle="card-collapse"
                          >
                            <i className="fe fe-chevron-up" />
                          </a>
                          <a
                            href="#"
                            className="card-options-fullscreen"
                            data-toggle="card-fullscreen"
                          >
                            <i className="fe fe-maximize" />
                          </a>
                          <a
                            href="#"
                            className="card-options-remove"
                            data-toggle="card-remove"
                          >
                            <i className="fe fe-x" />
                          </a>
                          <div className="item-action dropdown ml-2">
                            <a href="javascript:void(0)" data-toggle="dropdown">
                              <i className="fe fe-more-vertical" />
                            </a>
                            <div className="dropdown-menu dropdown-menu-right">
                              <a
                                href="javascript:void(0)"
                                className="dropdown-item"
                              >
                                <i className="dropdown-icon fa fa-eye" /> View
                                Details{" "}
                              </a>
                              <a
                                href="javascript:void(0)"
                                className="dropdown-item"
                              >
                                <i className="dropdown-icon fa fa-share-alt" />{" "}
                                Share{" "}
                              </a>
                              <a
                                href="javascript:void(0)"
                                className="dropdown-item"
                              >
                                <i className="dropdown-icon fa fa-cloud-download" />{" "}
                                Download
                              </a>
                              <div className="dropdown-divider" />
                              <a
                                href="javascript:void(0)"
                                className="dropdown-item"
                              >
                                <i className="dropdown-icon fa fa-copy" /> Copy
                                to
                              </a>
                              <a
                                href="javascript:void(0)"
                                className="dropdown-item"
                              >
                                <i className="dropdown-icon fa fa-folder" />{" "}
                                Move to
                              </a>
                              <a
                                href="javascript:void(0)"
                                className="dropdown-item"
                              >
                                <i className="dropdown-icon fa fa-edit" />{" "}
                                Rename
                              </a>
                              <a
                                href="javascript:void(0)"
                                className="dropdown-item"
                              >
                                <i className="dropdown-icon fa fa-trash" />{" "}
                                Delete
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="summernote">
                          Hello there,
                          <br />
                          <p>
                            The toolbar can be customized and it also supports
                            various callbacks such as <code>oninit</code>,{" "}
                            <code>onfocus</code>, <code>onpaste</code> and many
                            more.
                          </p>
                          <p>
                            Please try <b>paste some texts</b> here
                          </p>
                        </div>
                        <div className="timeline_item ">
                          <img
                            className="tl_avatar"
                            src="../assets/images/xs/avatar1.jpg"
                            alt
                          />
                          <span>
                            <a href="javascript:void(0);">Elisse Joson</a> San
                            Francisco, CA{" "}
                            <small className="float-right text-right">
                              20-April-2024 - Today
                            </small>
                          </span>
                          <h6 className="font600">
                            Hello, 'Im a single div responsive timeline without
                            media Queries!
                          </h6>
                          <div className="msg">
                            <p>
                              I'm speaking with myself, number one, because I
                              have a very good brain and I've said a lot of
                              things. I write the best placeholder text, and I'm
                              the biggest developer on the web card she has is
                              the Lorem card.
                            </p>
                            <a
                              href="javascript:void(0);"
                              className="mr-20 text-muted"
                            >
                              <i className="fa fa-heart text-pink" /> 12 Love
                            </a>
                            <a
                              className="text-muted"
                              role="button"
                              data-toggle="collapse"
                              href="#collapseExample"
                              aria-expanded="false"
                              aria-controls="collapseExample"
                            >
                              <i className="fa fa-comments" /> 1 Comment
                            </a>
                            <div
                              className="collapse p-4 section-gray mt-2"
                              id="collapseExample"
                            >
                              <form className="well">
                                <div className="form-group">
                                  <textarea
                                    rows={2}
                                    className="form-control no-resize"
                                    placeholder="Enter here for tweet..."
                                    defaultValue={""}
                                  />
                                </div>
                                <button className="btn btn-primary">
                                  Submit
                                </button>
                              </form>
                              <ul className="recent_comments list-unstyled mt-4 mb-0">
                                <li>
                                  <div className="avatar_img">
                                    <img
                                      className="rounded img-fluid"
                                      src="../assets/images/xs/avatar4.jpg"
                                      alt
                                    />
                                  </div>
                                  <div className="comment_body">
                                    <h6>
                                      Donald Gardner{" "}
                                      <small className="float-right font-14">
                                        Just now
                                      </small>
                                    </h6>
                                    <p>
                                      Lorem ipsum Veniam aliquip culpa laboris
                                      minim tempor
                                    </p>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div className="timeline_item ">
                          <img
                            className="tl_avatar"
                            src="../assets/images/xs/avatar4.jpg"
                            alt
                          />
                          <span>
                            <a href="javascript:void(0);" title>
                              Dessie Parks
                            </a>{" "}
                            Oakland, CA{" "}
                            <small className="float-right text-right">
                              19-April-2024 - Yesterday
                            </small>
                          </span>
                          <h6 className="font600">
                            Oeehhh, that's awesome.. Me too!
                          </h6>
                          <div className="msg">
                            <p>
                              I'm speaking with myself, number one, because I
                              have a very good brain and I've said a lot of
                              things. on the web by far... While that's mock-ups
                              and this is politics, are they really so
                              different? I think the only card she has is the
                              Lorem card.
                            </p>
                            <div className="timeline_img mb-20">
                              <img
                                className="width100"
                                src="../assets/images/gallery/1.jpg"
                                alt="Awesome Image"
                              />
                              <img
                                className="width100"
                                src="../assets/images/gallery/2.jpg"
                                alt="Awesome Image"
                              />
                            </div>
                            <a
                              href="javascript:void(0);"
                              className="mr-20 text-muted"
                            >
                              <i className="fa fa-heart text-pink" /> 23 Love
                            </a>
                            <a
                              className="text-muted"
                              role="button"
                              data-toggle="collapse"
                              href="#collapseExample1"
                              aria-expanded="false"
                              aria-controls="collapseExample1"
                            >
                              <i className="fa fa-comments" /> 2 Comment
                            </a>
                            <div
                              className="collapse p-4 section-gray mt-2"
                              id="collapseExample1"
                            >
                              <form className="well">
                                <div className="form-group">
                                  <textarea
                                    rows={2}
                                    className="form-control no-resize"
                                    placeholder="Enter here for tweet..."
                                    defaultValue={""}
                                  />
                                </div>
                                <button className="btn btn-primary">
                                  Submit
                                </button>
                              </form>
                              <ul className="recent_comments list-unstyled mt-4 mb-0">
                                <li>
                                  <div className="avatar_img">
                                    <img
                                      className="rounded img-fluid"
                                      src="../assets/images/xs/avatar4.jpg"
                                      alt
                                    />
                                  </div>
                                  <div className="comment_body">
                                    <h6>
                                      Donald Gardner{" "}
                                      <small className="float-right font-14">
                                        Just now
                                      </small>
                                    </h6>
                                    <p>
                                      Lorem ipsum Veniam aliquip culpa laboris
                                      minim tempor
                                    </p>
                                    <div className="timeline_img mb-20">
                                      <img
                                        className="width150"
                                        src="../assets/images/gallery/7.jpg"
                                        alt="Awesome Image"
                                      />
                                      <img
                                        className="width150"
                                        src="../assets/images/gallery/8.jpg"
                                        alt="Awesome Image"
                                      />
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div className="avatar_img">
                                    <img
                                      className="rounded img-fluid"
                                      src="../assets/images/xs/avatar3.jpg"
                                      alt
                                    />
                                  </div>
                                  <div className="comment_body">
                                    <h6>
                                      Dessie Parks{" "}
                                      <small className="float-right font-14">
                                        1min ago
                                      </small>
                                    </h6>
                                    <p>
                                      It is a long established fact that a
                                      reader will be distracted by the readable
                                      content of a page when looking
                                    </p>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div className="timeline_item ">
                          <img
                            className="tl_avatar"
                            src="../assets/images/xs/avatar7.jpg"
                            alt
                          />
                          <span>
                            <a href="javascript:void(0);" title>
                              Rochelle Barton
                            </a>{" "}
                            San Francisco, CA{" "}
                            <small className="float-right text-right">
                              12-April-2024
                            </small>
                          </span>
                          <h6 className="font600">
                            An Engineer Explains Why You Should Always Order the
                            Larger Pizza
                          </h6>
                          <div className="msg">
                            <p>
                              I'm speaking with myself, number one, because I
                              have a very good brain and I've said a lot of
                              things. I write the best placeholder text, and I'm
                              the biggest developer on the web by far... While
                              that's mock-ups and this is politics, is the Lorem
                              card.
                            </p>
                            <a
                              href="javascript:void(0);"
                              className="mr-20 text-muted"
                            >
                              <i className="fa fa-heart text-pink" /> 7 Love
                            </a>
                            <a
                              className="text-muted"
                              role="button"
                              data-toggle="collapse"
                              href="#collapseExample2"
                              aria-expanded="false"
                              aria-controls="collapseExample2"
                            >
                              <i className="fa fa-comments" /> 1 Comment
                            </a>
                            <div
                              className="collapse p-4 section-gray mt-2"
                              id="collapseExample2"
                            >
                              <form className="well">
                                <div className="form-group">
                                  <textarea
                                    rows={2}
                                    className="form-control no-resize"
                                    placeholder="Enter here for tweet..."
                                    defaultValue={""}
                                  />
                                </div>
                                <button className="btn btn-primary">
                                  Submit
                                </button>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="tab-pane" id="Agent-add">
                <div className="row clearfix">
                  <div className="col-lg-8 col-md-12 col-sm-12">
                    <div className="card">
                      <div className="card-header">
                        <h3 className="card-title">Basic Information</h3>
                        <div className="card-options ">
                          <a
                            href="#"
                            className="card-options-collapse"
                            data-toggle="card-collapse"
                          >
                            <i className="fe fe-chevron-up" />
                          </a>
                          <a
                            href="#"
                            className="card-options-remove"
                            data-toggle="card-remove"
                          >
                            <i className="fe fe-x" />
                          </a>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="row clearfix">
                          <div className="col-md-6 col-sm-12">
                            <div className="form-group">
                              <label>First Name</label>
                              <input type="text" className="form-control" />
                            </div>
                          </div>
                          <div className="col-md-6 col-sm-12">
                            <div className="form-group">
                              <label>Last Name</label>
                              <input type="text" className="form-control" />
                            </div>
                          </div>
                          <div className="col-md-6 col-sm-12">
                            <div className="form-group">
                              <label>Joining Date</label>
                              <input
                                data-provide="datepicker"
                                data-date-autoclose="true"
                                className="form-control"
                                placeholder
                              />
                            </div>
                          </div>
                          <div className="col-md-6 col-sm-12">
                            <label>Gender</label>
                            <select className="form-control show-tick">
                              <option value>-- Gender --</option>
                              <option value={10}>Male</option>
                              <option value={20}>Female</option>
                            </select>
                          </div>
                          <div className="col-md-6 col-sm-12">
                            <div className="form-group">
                              <label>Department</label>
                              <input type="text" className="form-control" />
                            </div>
                          </div>
                          <div className="col-md-6 col-sm-12">
                            <div className="form-group">
                              <label>Position</label>
                              <input type="text" className="form-control" />
                            </div>
                          </div>
                          <div className="col-md-6 col-sm-12">
                            <div className="form-group">
                              <label>Phone</label>
                              <input type="text" className="form-control" />
                            </div>
                          </div>
                          <div className="col-md-6 col-sm-12">
                            <div className="form-group">
                              <label>Enter Your Email</label>
                              <input type="text" className="form-control" />
                            </div>
                          </div>
                          <div className="col-sm-12">
                            <div className="form-group mt-2 mb-3">
                              <input type="file" className="dropify" />
                              <small
                                id="fileHelp"
                                className="form-text text-muted"
                              >
                                This is some placeholder block-level help text
                                for the above input. It's a bit lighter and
                                easily wraps to a new line.
                              </small>
                            </div>
                          </div>
                          <div className="col-sm-12">
                            <div className="form-group mt-3">
                              <label>Messages</label>
                              <textarea
                                rows={4}
                                className="form-control no-resize"
                                placeholder="Please type what you want..."
                                defaultValue={""}
                              />
                            </div>
                          </div>
                          <div className="col-sm-12">
                            <button type="submit" className="btn btn-primary">
                              Submit
                            </button>
                            <button
                              type="submit"
                              className="btn btn-outline-secondary"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-12 col-sm-12">
                    <div className="card">
                      <div className="card-header">
                        <h3 className="card-title">Account Information</h3>
                        <div className="card-options ">
                          <a
                            href="#"
                            className="card-options-collapse"
                            data-toggle="card-collapse"
                          >
                            <i className="fe fe-chevron-up" />
                          </a>
                          <a
                            href="#"
                            className="card-options-remove"
                            data-toggle="card-remove"
                          >
                            <i className="fe fe-x" />
                          </a>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="row clearfix">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label>User Name</label>
                              <input type="text" className="form-control" />
                            </div>
                          </div>
                          <div className="col-md-6 col-sm-12">
                            <div className="form-group">
                              <label>Password</label>
                              <input type="text" className="form-control" />
                            </div>
                          </div>
                          <div className="col-md-6 col-sm-12">
                            <div className="form-group">
                              <label>Confirm Password</label>
                              <input type="text" className="form-control" />
                            </div>
                          </div>
                          <div className="col-sm-12">
                            <button type="submit" className="btn btn-primary">
                              Submit
                            </button>
                            <button
                              type="submit"
                              className="btn btn-outline-secondary"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header">
                        <h3 className="card-title">Account Information</h3>
                        <div className="card-options ">
                          <a
                            href="#"
                            className="card-options-collapse"
                            data-toggle="card-collapse"
                          >
                            <i className="fe fe-chevron-up" />
                          </a>
                          <a
                            href="#"
                            className="card-options-remove"
                            data-toggle="card-remove"
                          >
                            <i className="fe fe-x" />
                          </a>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="form-group">
                          <label>Facebook</label>
                          <input type="text" className="form-control" />
                        </div>
                        <div className="form-group">
                          <label>Twitter</label>
                          <input type="text" className="form-control" />
                        </div>
                        <div className="form-group">
                          <label>LinkedIN</label>
                          <input type="text" className="form-control" />
                        </div>
                        <div className="form-group">
                          <label>Behance</label>
                          <input type="text" className="form-control" />
                        </div>
                        <div className="form-group">
                          <label>dribbble</label>
                          <input type="text" className="form-control" />
                        </div>
                        <button type="submit" className="btn btn-primary">
                          Submit
                        </button>
                        <button
                          type="submit"
                          className="btn btn-outline-secondary"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div classname="section-body">
          <footer classname="footer">
            <div classname="container-fluid">
              <div classname="row">
                <div className="col-md-6 col-sm-12">
                  Copyright © 2025{" "}
                  <a href="" style={{color: "#6e7687"}}>Technology support By - Siance Software Pvt Ltd</a>
                  .
                </div>
                {/* <div classname="col-md-6 col-sm-12 text-md-right">
                  <ul classname="list-inline mb-0">
                    <li classname="list-inline-item">
                      <a href="../doc/index.html">Documentation</a>
                    </li>
                    <li classname="list-inline-item">
                      <a href="javascript:void(0)">FAQ</a>
                    </li>
                    <li classname="list-inline-item">
                      <a
                        href="javascript:void(0)"
                        classname="btn btn-outline-primary btn-sm"
                      >
                        Buy Now
                      </a>
                    </li>
                  </ul>
                </div> */}
              </div>
            </div>
          </footer>
        </div>

      </div>

      {
          modalOpen ?
          <div 
          style={{width:"50%",height:"50%",top:"10rem",left:"30%",position:"absolute",zIndex:555,borderRadius:"10px",backgroundColor:"white",padding:"20px"}}>
            <p style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
              <span style={{fontSize:"25px",fontWeight:"700"}}>Adhaar Image</span>
              <span style={{cursor:"pointer"}} onClick={()=>setModalOpen(false)}>X</span>
            </p>

            <div style={{padding:"50px",borderRadius:"10px",border:"1px solid black",height:"80%",width:"100%"}}>
              {
                modalAgent.aadhaarImage!=="null"?
                  <img src={baseURL2+modalAgent.aadhaarImage}/>
                  :
                  <p>
                    Image is not Available
                  </p>

              }
            
            </div>

          </div>
          :""
        }
    </div>
  );
};
export default Agent;
